import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login', // A página inicial é o login
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'lista-clientes',
    loadComponent: () => import('./pages/clientes/lista-clientes/lista-clientes.page').then(m => m.ListaClientesPage),
  },
  {
    path: 'cliente-detalle',
    loadComponent: () => import('./pages/clientes/cliente-detalle/cliente-detalle.page').then(m => m.ClienteDetallePage),
  },
  {
    path: 'documentos',
    loadComponent: () => import('./pages/documentos/documentos.page').then(m => m.DocumentosPage),
  },
  {
    path: 'menu',
    loadComponent: () => import('./pages/menu/menu.page').then(m => m.MenuPage),
  },
  // --- ROTAS ADICIONADAS AQUI ---
  {
    path: 'clientes-pagares',
    loadComponent: () => import('./pages/pagares-pendientes/clientes-pagares.page').then(m => m.ClientesPagaresPage)
  },
  {
    path: 'pagares-pendientes',
    loadComponent: () => import('./pages/pagares-pendientes/lista-pagares.page').then(m => m.ListaPagaresPage)
  },
  {
    path: 'clientes-pagos',
    loadComponent: () => import('./pages/pagos-pendientes/clientes-pagos.page').then(m => m.ClientesPagosPage)
  },
  {
    path: 'pagos-pendientes',
    loadComponent: () => import('./pages/pagos-pendientes/lista-pagos.page').then(m => m.ListaPagosPage)
  },
  {
    path: 'clientes-pedidos',
    loadComponent: () => import('./pages/pedidos-venta/clientes-pedidos.page').then(m => m.ClientesPedidosPage)
  },
  {
    path: 'pedidos-venta',
    loadComponent: () => import('./pages/pedidos-venta/lista-pedidos.page').then(m => m.ListaPedidosPage)
  },
  {
    path: 'pedidos-venta/nuevo',
    loadComponent: () => import('./pages/pedidos-venta/nuevo-pedido/nuevo-pedido.page').then(m => m.NuevoPedidoPage)
  },
  {
    path: 'pedidos-venta/:id',
    loadComponent: () => import('./pages/pedidos-venta/detalle-pedido.page').then(m => m.DetallePedidoPage)
  },
  {
    path: 'lista-precios',
    loadComponent: () => import('./pages/lista-precios/lista-precios.page').then(m => m.ListaPreciosPage)
  },
  {
    path: 'metas',
    loadComponent: () => import('./pages/metas/metas.page').then(m => m.MetasPage)
  },
  {
    path: 'meta-form',
    loadComponent: () => import('./pages/metas/meta-form/meta-form.page').then(m => m.MetaFormPage)
  },
  {
    path: 'seleccionar-producto',
    loadComponent: () => import('./pages/seleccionar-producto/seleccionar-producto.page').then(m => m.SeleccionarProductoPage)
  },
  {
    path: 'configuraciones',
    loadComponent: () => import('./pages/configuraciones/configuraciones.page').then(m => m.ConfiguracionesPage)
  },
  {
    path: 'api-test',
    loadChildren: () => import('./pages/api-test/api-test.module').then(m => m.ApiTestPageModule)
  },
  {
    path: 'historial-ventas-anual',
    loadComponent: () => import('./pages/historial-ventas-anual/historial-ventas-anual.page').then(m => m.HistorialVentasAnualPage)
  },
  {
    path: 'lista-produtos',
    loadComponent: () => import('./pages/lista-produtos/lista-produtos.page').then( m => m.ListaProdutosPage)
  },

];
